import { DevicesParams, DevicesCampaignParams } from '@/services/ElasticApi';
import {
    DeviceDetailsInterface,
    DevicesFetchStartAction,
    DevicesFetchSuccessAction,
    DevicesFetchErrorAction,
    DevicesCampaignsFetchStartAction,
    DevicesCampaignsFetchSuccessAction,
    DevicesCampaignsFetchErrorAction,
} from './types';
import { ReportsActionTypes } from '../types';
import { ApplicationState } from '../..';

export const DevicesFetchStart = (params: DevicesParams): DevicesFetchStartAction => ({
        type: ReportsActionTypes.GET_DEVICE_DETAILS,
        payload: params,
    });
export const DevicesFetchSuccess = (params: DeviceDetailsInterface): DevicesFetchSuccessAction => ({
        type: ReportsActionTypes.GET_DEVICE_DETAILS_SUCCESS,
        payload: params,
    });
export const DevicesFetchError = (): DevicesFetchErrorAction => ({
        type: ReportsActionTypes.GET_DEVICE_DETAILS_ERROR,
    });

export const DevicesCampaignsFetchStart = (params: DevicesCampaignParams): DevicesCampaignsFetchStartAction => ({
        type: ReportsActionTypes.GET_DEVICE_DETAILS_CAMPAIGNS,
        payload: params,
    });
export const DevicesCampaignsFetchSuccess = (params: DeviceDetailsInterface): DevicesCampaignsFetchSuccessAction => ({
        type: ReportsActionTypes.GET_DEVICE_DETAILS_CAMPAIGNS_SUCCESS,
        payload: params,
    });
export const DevicesCampaignsFetchError = (): DevicesCampaignsFetchErrorAction => ({
        type: ReportsActionTypes.GET_DEVICE_DETAILS_CAMPAIGNS_ERROR,
    });

export const getDeviceDetailsStore = (state: ApplicationState): DeviceDetailsInterface => state.reports?.deviceDetails;
